<template>
  <common-dialog
    ref="dialog"
    :title="title"
    width="1100px"
    :in-dialog="inDialog"
  >
    <list
      ref="list"
      common
      :show-checkbox="multiple"
      :is_listDialog="true"
      :is-show="true"
      :modelType="modelType"
      :TradeUnitId="TradeUnitId"
      :isSelect="true"
    >
      <template #column>
        <slot name="column" />
        <template v-if="selectable && !multiple">
          <el-table-column label="操作" align="center" width="60" fixed="right">
            <template slot-scope="{ row }">
              <el-button
                :disabled="row.DistrictId == NoId"
                @click="onSelect(row)"
                type="text"
                >选择</el-button
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </list>
    <template slot="footer">
      <slot name="footer">
        <el-button
          type="primary"
          @click="selectMultiple"
          v-if="selectable && multiple"
          >选择</el-button
        >
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";

export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "新采购需求列表",
    },
    modelType: {
      type: String,
      default: "businesspurchaseinquiry",
    },
    TradeUnitId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      params: {},
      NoId: 0,
    };
  },
  watch: {
    TradeUnitId(){
      if(this.$refs.list){
        this.$refs.list.clearList()
      }
    }
  },
  methods: {
    selectMultiple() {
      let data = {
        Order: this.$refs.list.orderNo,
        List: this.$refs.list.subSelectList,
      };
      this.$emit("select-multiple", data);
      this.$refs.list.clearSubSelectList()
      this.close();
    },
    getData(params = {}) {
      this.params = { ...params };
      this.$refs.list.getData(this.params);
    },
    treeSelect(data) {
      this.$refs.list.getData({ ...this.params, IdChain: data.IdChain });
    },
    titleClick() {
      this.$refs.list.getData({ ...this.params, IdChain: null });
    },
  },
};
</script>
